import classNames from "classnames";
import { memo, useMemo } from "react";
import TimePicker from "react-time-picker";
import * as styles from "./redo-time-picker.module.css";

export interface TimeOfDay {
  hours: number;
  minutes: number;
}

/**
 * This component is currently trash.
 * We are planning on using it however with an immutable interface so that when we give
 * it the love it needs we get the updates everywhere else.
 */
export type RedoTimePickerSize = "xs" | "sm" | "md" | "lg" | "xl";

export const RedoTimePicker = memo(function RedoTimePicker({
  value,
  setValue,
  size = "sm",
  disabled = false,
  className,
  clearIcon,
}: {
  value: TimeOfDay | null;
  setValue: (value: TimeOfDay | null) => void;
  size?: RedoTimePickerSize;
  disabled?: boolean;
  className?: string;
  clearIcon?: React.ReactNode | null;
}) {
  function handleTimeChange(timeString: string | null) {
    if (!timeString) {
      setValue(null);
    } else {
      const [hours, minutes] = timeString
        .split(":")
        .map((str) => parseInt(str, 10));
      // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
      setValue({ hours, minutes });
    }
  }

  const valueStr = useMemo(() => {
    if (!value) {
      return null;
    }
    return `${value.hours.toString().padStart(2, "0")}:${value.minutes.toString().padStart(2, "0")}`;
  }, [value]);

  return (
    <div data-arbiter="RedoTimePicker" style={{ display: "contents" }}>
      <TimePicker
        className={classNames(
          styles.redoTimePicker,
          styles[size],
          disabled && styles.disabled,
          className,
        )}
        clearIcon={clearIcon}
        disableClock
        disabled={disabled}
        onChange={handleTimeChange}
        value={valueStr}
      />
    </div>
  );
});
